import { Upload } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';

import styles from './FileInput.module.scss';

const { Dragger } = Upload;

type FileCustom = Exclude<File, string>

type Props = {
  onChangeFile: (selectedFile: File) => void;
  validate?: (file: FileCustom) => void | boolean;
  loading?: boolean;
  disabled?: boolean;
  title?: string;
  accept: string;
  defaultPreviewValue?: ReactElement | string;
};

const FileInput = ({ onChangeFile, validate, loading, disabled, title, accept, defaultPreviewValue }: Props) => {
  const [file, setFile] = useState<File>();

  useEffect(() => {
    if (!file)
      return;

    if (!validate)
      return onChangeFile(file);

    if (!validate(file))
      return setFile(void 0);

    onChangeFile(file);
  }, [file, onChangeFile, validate]);

  return (
    <Dragger className={styles.dropArea}
             name="file"
             accept={accept || "image/*"}
             showUploadList={false}
             //@ts-ignore
             customRequest={({file, onSuccess}) => onSuccess({status: 200}, file)}
             multiple={false}
             onChange={event => setFile(event.file.originFileObj as File)}
             disabled={loading || disabled}>
      <div className={styles.dropAreaChildren}>
        <p className={styles.text}><span className={styles.tint}>{title || 'Arraste e solte um arquivo aqui!'}</span></p>
        <p className={styles.text}>Ou <span className={styles.tint}>clique </span>para escolher um arquivo</p>
        {!file && defaultPreviewValue && (
          <p className={styles.text}>{defaultPreviewValue}</p>
        )}
        {file && (
          <p className={styles.text}>Selecionado: <span className={styles.tint}>{file.name}</span></p>
        )}
      </div>
    </Dragger>
  );
}

export default FileInput;